/* ================================================================
   KI – Collection Page JS
   Pack selector + Quick Add + AJAX Filter/Sort
   ================================================================ */
(function () {
  'use strict';

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: { resource: cart, sourceId: 'ki-collection', data: { itemCount: cart.item_count } }
    }));
  }

  /* ================================================================
     PACK VARIANT SELECTOR
     Clicking a pack box updates selected state + ADD button variant
     ================================================================ */
  document.addEventListener('click', function (e) {
    const pack = e.target.closest('.kc-card__pack');
    if (!pack) return;

    const card = pack.closest('.kc-card');
    if (!card) return;

    card.querySelectorAll('.kc-card__pack').forEach(function (p) {
      p.classList.remove('kc-card__pack--selected');
      p.setAttribute('aria-pressed', 'false');
    });
    pack.classList.add('kc-card__pack--selected');
    pack.setAttribute('aria-pressed', 'true');

    const addBtn = card.querySelector('.kc-card__add-btn');
    if (addBtn && pack.dataset.variantId) {
      addBtn.dataset.variantId = pack.dataset.variantId;
    }
  });

  /* ================================================================
     ADD TO CART  (.kc-card__add-btn)
     ================================================================ */
  document.addEventListener('click', async function (e) {
    const btn = e.target.closest('.kc-card__add-btn[data-variant-id]');
    if (!btn || btn.disabled) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const origText = btn.textContent;
    btn.classList.add('kc-card__add-btn--loading');
    btn.textContent = 'Adding…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
      });

      if (res.ok) {
        const cart = await fetch('/cart.js').then(r => r.json());
        dispatchCartUpdate(cart);
        btn.classList.remove('kc-card__add-btn--loading');
        btn.classList.add('kc-card__add-btn--added');
        btn.textContent = '✓ Added!';
        setTimeout(function () {
          btn.classList.remove('kc-card__add-btn--added');
          btn.textContent = origText;
        }, 2000);
      } else {
        throw new Error('failed');
      }
    } catch {
      btn.classList.remove('kc-card__add-btn--loading');
      btn.textContent = 'Try again';
      setTimeout(function () { btn.textContent = origText; }, 2000);
    }
  });

  /* ================================================================
     SORT SELECT → AJAX reload
     ================================================================ */
  document.addEventListener('change', function (e) {
    const select = e.target.closest('.kc-sort-select');
    if (!select) return;

    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    navigateTo(url.toString());
  });

  /* ================================================================
     FILTER CHECKBOXES → AJAX reload (desktop)
     ================================================================ */
  document.addEventListener('change', function (e) {
    const check = e.target.closest('.kc-filter-check');
    if (!check) return;

    const form = check.closest('form.kc-filter-bar, form');
    if (!form) return;

    const url = buildFilterURL(form);
    navigateTo(url);
  });

  /* Drawer filter checkboxes */
  document.addEventListener('change', function (e) {
    const check = e.target.closest('.kc-filter-check--drawer');
    if (!check) return;
    const targetUrl = check.checked ? check.dataset.urlAdd : check.dataset.urlRemove;
    if (targetUrl) {
      closeDrawer();
      navigateTo(targetUrl);
    }
  });

  /* Price apply — prevent default form submit */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.kc-price-apply-btn');
    if (!btn) return;
    e.preventDefault();
    const form = btn.closest('form');
    if (!form) return;
    navigateTo(buildFilterURL(form));
  });

  /* Active chip remove */
  document.addEventListener('click', function (e) {
    const chip = e.target.closest('.kc-active-chip');
    if (!chip) return;
    e.preventDefault();
    navigateTo(chip.href);
  });

  function buildFilterURL(form) {
    const url = new URL(window.location.href);
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('filter.')) url.searchParams.delete(key);
    }
    url.searchParams.delete('page');

    const data = new FormData(form);
    for (const [key, val] of data.entries()) {
      if (key.startsWith('filter.') && val !== '') {
        url.searchParams.append(key, val);
      }
    }
    return url.toString();
  }

  /* ── AJAX section render ──────────────────────────────────── */
  async function navigateTo(url) {
    const section = document.querySelector('.kc-products[data-section-id]');
    if (!section) { window.location.href = url; return; }

    const sectionId = section.dataset.sectionId;
    section.classList.add('kc-loading');

    try {
      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', sectionId);

      const html = await fetch(fetchUrl.toString()).then(r => r.text());
      const doc  = new DOMParser().parseFromString(html, 'text/html');
      const newSection = doc.querySelector('.kc-products');

      if (newSection) {
        section.innerHTML      = newSection.innerHTML;
        section.className      = newSection.className;
        section.style.cssText  = newSection.style.cssText;
        window.history.pushState({}, '', url);
      } else {
        window.location.href = url;
      }
    } catch {
      window.location.href = url;
    }

    section.classList.remove('kc-loading');
  }

  window.addEventListener('popstate', function () { window.location.reload(); });

  /* ================================================================
     FILTER DROPDOWN TOGGLES — delegated (no re-init needed)
     ================================================================ */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.kc-filter-btn');
    if (btn) {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns();
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        const drop = document.getElementById(btn.getAttribute('aria-controls'));
        if (drop) drop.hidden = false;
      }
      return;
    }
    if (!e.target.closest('.kc-filter-group')) closeAllDropdowns();
  });

  function closeAllDropdowns() {
    document.querySelectorAll('.kc-filter-btn[aria-expanded="true"]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
      const drop = document.getElementById(b.getAttribute('aria-controls'));
      if (drop) drop.hidden = true;
    });
  }

  /* ================================================================
     MOBILE FILTER DRAWER — delegated
     ================================================================ */
  function openDrawer() {
    const drawer  = document.getElementById('kc-filter-drawer');
    const overlay = document.getElementById('kc-drawer-overlay');
    const openBtn = document.getElementById('kc-filter-open');
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.removeAttribute('aria-hidden');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
  }

  function closeDrawer() {
    const drawer  = document.getElementById('kc-filter-drawer');
    const overlay = document.getElementById('kc-drawer-overlay');
    const openBtn = document.getElementById('kc-filter-open');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#kc-filter-open'))                                           { openDrawer();  return; }
    if (e.target.closest('#kc-filter-close') || e.target.closest('.kc-drawer-apply')) { closeDrawer(); return; }
    if (e.target.closest('#kc-drawer-overlay'))                                        { closeDrawer(); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

})();
